<template>
  <div>
    <el-button type="text" @click="lookSerialNumber">
      查看
    </el-button>
    <div style="text-align: left">
      <el-dialog title="序列号明细" :visible.sync="SerialNumberVisible" width="520px">
        <div v-loading="SerialNumberLoading">
          <el-button type="primary" style="margin-bottom: 10px">
            导出序列号
          </el-button>
          <el-table :data="SerialtableData" border style="width: 100%">
            <el-table-column type="index" width="70" label="序号" />
            <el-table-column prop="sellTime" label="出货日期" align="left" />
            <el-table-column prop="productName" label="产品名称" align="left" />
            <el-table-column prop="barcodeNumber" label="序列号" align="left" />
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script type="es6">
import { getSerialNumberListByContract } from '@/API';
export default {
  data () {
    return {
      SerialNumberVisible: false,
      SerialNumberLoading: false,
      SerialtableData: []
    };
  },
  props: {
    strContractCode: {
      type: String,
      required: true
    },
    productName: {
      type: String,
      required: true
    },
    specialProductList: {
      type: [Object, Number],
      default: () => { return null; }
    }
  },
  components: {
  },
  computed: {},
  methods: {
    lookSerialNumber (row) {
      this.SerialtableData = [];
      this.SerialNumberVisible = true;
      this.SerialNumberLoading = true;
      getSerialNumberListByContract(this.strContractCode, this.productName, this.specialProductList).then((res) => {
        let json = res.data;
        this.SerialNumberLoading = false;
        if (json.status === '200') {
          this.SerialtableData = json.data;
        }
      }).catch(() => {
        this.SerialNumberLoading = false;
      });
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss">
</style>
